import React, { useState, useEffect, useMemo } from 'react';
import { Button, Layout, Segment, Table, Justify, notification } from 'tea-component';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { history, useIntl, useSelector, getLocale } from 'umi';
import '@/pages/intelligence/assets/scss/Following/manage.scss';
import { getCountryFlag } from '@/pages/home/_config/countries';
import AddGroup from './AddGroup';
import UnfollowModal from './UnfollowModal';
import RenameAddGroup from './RenameAddGroup';
import DeleteGroup from './DeleteGroup';
import FollowMultipleChoice from '@/pages/intelligence/pages/Following/components/FollowMultipleChoice';
import {
  fetchFollowingGroups,
  getAllGamesFollowList,
  fetchUnfollowing,
  groupCopy,
  getFollowingSearch,
  getFollowingShuttleFrameList,
  getCompareEntityTypeSearch,
  followSearchPullDown,
  createCollectionFollow,
  getSearchNewList,
} from '@/pages/intelligence/services/following';
import {
  getGameStateType,
  getCopyName,
  DEFAULTPAGESIZE,
  getManagerDbiPageLogMes,
} from '@/pages/intelligence/pages/Following/Manage/Utils/following';
import SubTable from '@/pages/intelligence/pages/Following/Manage/SubTable';
import Loading from '@/pages/intelligence/components/Loading';
import { FormMode } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { useFollowingOptionList } from '@/pages/intelligence/pages/Following/_hook/useFollowingOptionList';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { MANAGER_GROUP_NAME } from '@/pages/intelligence/pages/Following/_config/constant';
import FollowingNoData from '@/pages/intelligence/pages/Following/components/FollowingNoData';
import AddEntities from '@/pages/intelligence/pages/Following/components/AddEntities';
import { getCountryCodeByCountryName } from '@/pages/intelligence/utils/commonUtils';
import useInitSearchInput from '@intelligence/pages/Following/Manage/_hooks/useInitSearchInput';
import useFollowingGamesPagable from '@intelligence/pages/Following/Manage/_hooks/useFollowingGamesPagable';
import { analysisGroups } from '@intelligence/pages/Following/Manage/Utils/following';

import type { PagingQuery } from 'tea-component';
import type { IFollowingGroup, IFollowingGame } from '@intelligence/pages/Following/Manage/types';
const { Body, Content } = Layout;
const { expandable, pageable } = Table.addons;

const filterCommonGroups = <T extends IFollowingGroup>(groups: T[]): T[] => {
  if (!Array.isArray(groups)) return [];
  return groups.filter((group) => group?.entity_name !== MANAGER_GROUP_NAME.allgames.text);
};

export default function Manage() {
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const [createRenameGroup, setCreateRenameGroup] = useState(false);
  const [addGroup, setAddGroup] = useState(false);
  const [unfollow, setUnfollow] = useState(false);
  const [deleteGroup, setDeleteGroup] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState<any>([]);

  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return { userInfo };
  });
  const userId = userInfo?.userid ?? '';

  // console.log('userInfouserInfouserInfo', userInfo);
  const urlParams = location.pathname.split('/');
  const { follwowingSegOptions } = useFollowingOptionList({});
  // 增加纯国家列表以用来简称匹配全称用
  const [regionsCountries, setRegionsCountries] = useState<any>([]);
  // 获取全局国家地区数据
  const { regionOptions } = useMarketFilterApi({});
  useEffect(() => {
    setRegionsCountries(regionOptions);
  }, [regionOptions]);

  const defulatGameType = getGameStateType(urlParams[urlParams?.length - 1]).type;
  const [mainSegment, setMainSegment] = useState(defulatGameType);
  const [loading, setLoading] = useState(true);
  const [gameLoading, setGameLoading] = useState(false);

  const [checkList, setCheckList] = useState<any>([]);
  // 所有分组
  const [groups, setGroups] = useState<IFollowingGroup[]>([]);
  // 缓存groups分组，用于清空搜索时 重新赋值给groups
  const [groupsCached, setGroupsCached] = useState<IFollowingGroup[]>([]);
  // 所有分组，过滤调All Games分组
  const groupList = useMemo<IFollowingGroup[]>(() => filterCommonGroups(groups), [groups]);
  const groupListCached = useMemo<IFollowingGroup[]>(
    () => filterCommonGroups(groupsCached),
    [groupsCached],
  );
  // 新增、重命名分组 区分标识
  const [mode, setMode] = useState<FormMode>(FormMode.Add);
  const [group, setGroup] = useState<any>(null);

  const [defaultSearchNodataList, setDefaultSearchNodataList] = useState<IFollowingGame[]>([]);
  const [addNewGroupName, setAddNewGroupName] = useState('');
  const [favarite, setFavarite] = useState<any>(false);
  const [groupOptions, setGroupOptions] = useState<any[]>([]);
  const [isAddToGroup, setIsAddToGroup] = useState(false);
  const [visible, setVisible] = useState(false);
  // All Games分组下游戏id集合
  const [allGameListIds, setAllGameListIds] = useState<string[]>([]);

  // 内嵌表格勾选列表
  const [checkTableList, setCheckTableList] = useState<any>([]);
  const [checkAllGamesList, setCheckAllGamesList] = useState<any>([]);
  const [checkTrueGameIds, setCheckTrueGameIds] = useState<any>([]);

  // const DEFAULT_GROUPNAME_Only_Games = useMemo(() => {
  //   const nameObj = MANAGER_GROUP_NAME.allgames;
  //   return locale === 'zh-CN' ? nameObj.textcn : nameObj.text;
  // }, [mainSegment, locale]);

  const DEFAULT_GROUPNAME = useMemo(() => {
    const nameObj =
      mainSegment == 'company' ? MANAGER_GROUP_NAME.allcompanies : MANAGER_GROUP_NAME.allgames;
    return locale === 'zh-CN' ? nameObj.textcn : nameObj.text;
  }, [mainSegment, locale]);

  const ALLGAMES = useMemo(() => {
    const nameObj = MANAGER_GROUP_NAME.allgames;
    return locale === 'zh-CN' ? nameObj.textcn : nameObj.text;
  }, [locale]);

  const MYFAVOURITE = useMemo(() => {
    const nameObj = MANAGER_GROUP_NAME.myfavourite;
    return locale === 'zh-CN' ? nameObj.textcn : nameObj.text;
  }, [locale]);

  const SPECIAL_NAMES = useMemo(() => {
    return {
      [MANAGER_GROUP_NAME.allgames.text]: ALLGAMES,
      [MANAGER_GROUP_NAME.myfavourite.text]: MYFAVOURITE,
    };
  }, [ALLGAMES, MYFAVOURITE]);

  const groupName = useMemo(() => {
    if (!group) return '';
    return group.entity_name ?? '';
  }, [group]);

  // 当前搜索游戏id
  const [searchId, setSearchId] = useState('');
  const gamesField = mainSegment === 'company' ? 'company_data' : 'GameData';
  const initSearchInput = useInitSearchInput(mainSegment);
  const {
    sorts,
    pagingQuerys,
    loadings,
    games,
    onGroupSortChange,
    onGroupPagingQueryChange,
    onGroupExpand,
  } = useFollowingGamesPagable({
    lazy: true,
    gamesField,
    // 排序字段初始值
    initialOrderField: 'following_time',
    // 排序方式初始值
    initialOrder: 'desc',
    groups,
    expandedGroups: expandedKeys,
    // 获取指定分组下游戏集合（公司集合）接口的入参
    fetchParams: {
      // 用户id
      user_id: userId,
      // 实体类型mobile、pc、console、company
      game_type: mainSegment,
      // 游戏id（公司id）
      search_id: searchId,
    },
  });
  // 渲染展开表格无数据UI
  const renderGroupGamesNoDataUI = (groupKey: string) => {
    if (groupKey === DEFAULT_GROUPNAME)
      return <FollowingNoData entityType={mainSegment} isNewGame={false} setVisible={setVisible} />;
    if (mainSegment === 'company') return formatMessage({ id: 'dbi_there_no_companies_group' });
    return formatMessage({ id: 'dbi_there_no_game_group' });
  };

  useEffect(() => {
    setDefaultSearchNodataList([]);
  }, [mainSegment]);

  const goAllGamesfollowPage = async (segment = mainSegment) => {
    clearList();
  };

  const fetchCancelUnfollowing = async () => {
    try {
      await fetchUnfollowing({
        users_id: userId,
        unified_ids: checkTrueGameIds || [],
      });
      getPageDatas();
    } catch (err) {}
  };
  //   执行取消关注接口
  const cancelUnfollowing = () => {
    fetchCancelUnfollowing();
  };

  // 切换 pc、console、mobile时 重置 selectedGames为空，避免影响 需要判断 selectedGames的功能
  useEffect(() => {
    clearList();
    const mesKey = getManagerDbiPageLogMes(mainSegment);
    buriedPointPage(dbiPageLogMes[mesKey]);
  }, [mainSegment]);

  const clearList = () => {
    if (!isAddToGroup) {
      setCheckTableList([]);
      setCheckAllGamesList([]);
      setCheckTrueGameIds([]);
      setCheckList([]);
    }
  };

  const getGroupGameList = async (apiData: any, isSearch?: boolean) => {
    setLoading(true);
    clearList();
    try {
      const res = await fetchFollowingGroups({ ...apiData, hasAllGames: true });
      const groups = analysisGroups(res?.data?.group_lists);
      const allGroups = groups.all;
      const allGamesGroupList = groups.allGames;
      const allGamesGroupGamesIds = allGamesGroupList?.[0]?.group_game_ids || [];
      if (!isSearch) {
        setGroupsCached(allGroups);
        setAllGameListIds(allGamesGroupGamesIds);
      }
      setGroups(allGroups);
    } catch (err) {
      setGroups([]);
      if (!isSearch) {
        setAllGameListIds([]);
      }
    }
    setLoading(false);
  };

  const getPageDatas = async () => {
    setLoading(true);
    goAllGamesfollowPage(mainSegment);
    getGroupGameList({ entity_type: mainSegment });
  };

  useEffect(() => {
    if (userId) {
      getPageDatas();
    }
  }, [userId]);

  /** 切换指标函数 */
  const handleChangeSeg = (_entityType = mainSegment) => {
    // if (!isAddToGroup) {
    getGroupGameList({ entity_type: _entityType });
    // }
  };

  const handleGreateGroup = async () => {
    setMode(FormMode.Add);
    setGroup(null);
    setCreateRenameGroup(true);
  };

  const handleEditPre = (group: any) => {
    if (!group) return;
    setMode(FormMode.Edit);
    setGroup(group);
    setCreateRenameGroup(true);
  };

  const handleDeletePre = (group: any) => {
    if (!group) return;
    setCheckList([group.entity_name]);
    setDeleteGroup(true);
  };

  const changeMainSegment = (val: string) => {
    setMainSegment(val);
    setSearchId('');
    setGroups([]);
    setCheckAllGamesList([]);
    handleChangeSeg(val);
    // goAllGamesfollowPage(val);
    history.push(`/intelligence/following/manage/${val}`);
  };

  const handleGroupCopy = async (_apiData: any) => {
    setLoading(true);
    try {
      const res = await groupCopy(_apiData);
      if (res?.code === 0 || res?.code === 200) {
        await getGroupGameList({
          entity_type: mainSegment,
        });
      } else {
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleDuplicate = (group: any) => {
    handleGroupCopy({
      entity_type: group?.entity_type,
      entity_name: group?.entity_name, // 被复制的分组名称
      copy_entity_name: getCopyName(groupList, group?.entity_name), // 新复制的分组名称
    });
  };

  const getGroupCheckHandle = (val: string, group: any) => {
    setCheckTableList([]);
    setCheckAllGamesList([]);
    setCheckTrueGameIds([]);
    const groupTrueList = groupList?.filter((item: any) => item.entity_name != 'My favourite');
    const listTemp: any = checkList;
    let list: any = [];
    if (group == 'allgroup') {
      setCheckList(val ? groupTrueList?.map((item: any) => item.entity_name) || [] : []);
    } else {
      if (val) {
        if (!listTemp?.includes(group)) {
          listTemp?.push(group);
        }
        for (const n in listTemp) {
          list.push(listTemp[n]);
        }
      } else {
        list = listTemp?.filter((item: any) => item != group);
      }
      setCheckList(list);
    }
  };

  const handleAddGroupClose = () => {
    if (!isAddToGroup) {
      getPageDatas();
    }
    setAddGroup(false);
  };

  const handleGroupSettingPre = async () => {
    setIsAddToGroup(true);
    handleFollowingGroups();
  };

  const openAddUpateGroup = async () => {
    handleFollowingGroups();
    setIsAddToGroup(false);
  };

  const handleFollowingGroups = async () => {
    try {
      const params = {
        entity_type: mainSegment,
      };
      const res = await fetchFollowingGroups(params);
      const groupList = res?.data?.group_lists;

      const groupOption = groupList?.map((item: any) => {
        return {
          value: item?.entity_name,
          text: `${item?.entity_name === 'My favourite' ? MYFAVOURITE : item?.entity_name} (${
            item?.game_list_total
          })`,
        };
      });
      setGroupOptions(groupOption);
      setAddGroup(true);
    } catch (exception) {
      setGroupOptions([
        {
          value: DEFAULT_GROUPNAME,
          text: `${DEFAULT_GROUPNAME} (0)`,
        },
      ]);
      console.warn(exception);
    }
  };

  const groupNames = useMemo(() => {
    if (!Array.isArray(groupList)) return [];
    return groupList
      .filter((item: any) => item && item.entity_type === mainSegment)
      .map((item: any) => item.entity_name);
  }, [groupList]);

  const handleClearSearch = () => {
    // 还原搜索前的数据，不调接口
    // getPageDatas();
    setGroups(groupsCached);
    setSearchId('');
  };

  const getTableSearchList = (id: string) => {
    getGroupGameList(
      {
        entity_type: mainSegment,
        game_company_id: id,
      },
      true,
    );
    setSearchId(id);
  };

  const transTableDataForSearch = (res: any) => {
    const resultList = res?.data || [];
    if (!Array.isArray(resultList) || !resultList?.length) {
      return [];
    }
    const tranksList: any[] = resultList.map((item) => {
      return {
        id: item?.game_id,
        imgSrc: item?.cover,
        lineOneStr: item?.game_name,
        lineTwoImg: getCountryFlag(item?.country_abbre),
        lineTwoImgName: item?.country_abbre,
        lineTwoStr: item?.publisher,
        country_abbre: item?.country_abbre,
      };
    });
    return tranksList;
  };

  const transTableDataForSearch2 = (resultList: any) => {
    const isCompany = mainSegment == 'company';
    if (!Array.isArray(resultList) || !resultList?.length) {
      return [];
    }
    const tranksList: any[] = resultList.map((item) => {
      return {
        id: item?.app_id,
        imgSrc: isCompany ? item?.image_url || item?.cover : item?.cover,
        lineOneStr: item?.name,
        lineTwoImg: getCountryFlag(item?.publisher_addr),
        lineTwoImgName: item?.publisher_addr,
        lineTwoStr: isCompany
          ? `${item.location_identifiers_city} ${item.location_identifiers_country}`
          : item?.publisher,
      };
    });
    return tranksList;
  };

  const handleFollowConfirm = async (checkedList) => {
    setVisible(false);
    const params = {
      game_company_ids: checkedList,
      entity_type: mainSegment,
      group_name: ['All Games'],
      user_id: userInfo?.userid,
      is_overwrite: true,
    };

    try {
      await createCollectionFollow(params);
      await getPageDatas();
      const { destroy } = notification.success({
        unique: true,
        description: (
          <div>
            <span>{formatMessage({ id: 'dbi_success_follow' })}</span>
            <span
              style={{ color: '#326FF0', cursor: 'pointer', marginLeft: 10 }}
              onClick={() => handleAddToGroup(destroy, checkedList)}
            >
              {formatMessage({ id: 'dbi_add_to_group' })}
            </span>
          </div>
        ),
      });
    } catch (error) {
      notification.error({
        unique: true,
        description: formatMessage({ id: 'dbi_failed_follow' }),
      });
    }
  };

  const handleAddToGroup = async (destroy, checkedList) => {
    setCheckTrueGameIds(checkedList);
    destroy?.();
    // 若默认分组只有All Games，在提示点击Add to a Group后弹出Create a New Group弹窗
    if (groupList.length > 0) {
      await handleFollowingGroups();
      setAddGroup(true);
    } else {
      setCreateRenameGroup(true);
    }
    setIsAddToGroup(true);
  };

  const allGameTotal = useMemo(() => {
    return allGameListIds?.length || 0;
  }, [allGameListIds]);

  const getLeftCellTitle = (entityType) => {
    switch (entityType) {
      case 'mobile':
        return 'dbi_top10_revenue';
      case 'pc':
      case 'console':
        return 'dbi_top10_digital';
      case 'company':
        return 'dbi_top10_sum_rev';
      default:
        return '';
    }
  };

  /** 获取默认搜索时，无数据展示的列表 */
  const getDefaultSeachNodataList = async (gameType: string) => {
    setGameLoading(true);
    try {
      const res = await getAllGamesFollowList({
        game_type: gameType,
        group_name: MANAGER_GROUP_NAME.allgames.text,
        search_id: '',
        order_filed: 'following_time',
        order: 'desc',
        page: 1,
        page_size: 10,
        user_id: userId,
      });
      let list = res?.data?.[gamesField];
      list = Array.isArray(list) ? list : [];
      setDefaultSearchNodataList(list);
    } catch (err) {
      setDefaultSearchNodataList([]);
    } finally {
      setGameLoading(false);
    }
  };

  useEffect(() => {
    setDefaultSearchNodataList([]);
    getDefaultSeachNodataList(mainSegment);
  }, [mainSegment]);

  const disAddToGroup = useMemo(() => {
    return checkAllGamesList.length < 1;
  }, [mainSegment, checkAllGamesList, checkTrueGameIds]);

  return (
    <Layout className="dbi-manage-page">
      <Body>
        <Content>
          <Content.Header
            showBackButton
            onBackButtonClick={() => {
              history.push('/intelligence/following');
            }}
            title={formatMessage({ id: 'dbi_manage' })}
          />
          <Content.Body full>
            <div className="dbi-manage-page-flex">
              <Segment
                className="segment-light manage-segment"
                value={mainSegment}
                onChange={(value) => changeMainSegment(value)}
                options={follwowingSegOptions}
                disabled={gameLoading}
              />
            </div>

            <Justify
              className="dbi-pcGame-jf pc-metricstable-jf dbi-card-justify"
              left={
                <>
                  <Button
                    type="primary"
                    className="manage-btn"
                    disabled={loading}
                    onClick={() => setVisible(true)}
                  >
                    {formatMessage({
                      id:
                        mainSegment === 'company'
                          ? 'dbi_follow_new_companies'
                          : 'dbi_follow_new_games',
                    })}
                  </Button>
                  <Button
                    type="text"
                    className="ns-btn--border manage-btn"
                    disabled={checkTrueGameIds.length < 1}
                    onClick={() => {
                      setUnfollow(true);
                    }}
                  >
                    {formatMessage({ id: 'dbh_unfollow' })}
                  </Button>
                  <Button
                    type="text"
                    className="ns-btn--border manage-btn"
                    onClick={() => handleGreateGroup()}
                  >
                    {formatMessage({ id: 'dbi_create_new_group' })}
                  </Button>
                  <Button
                    type="text"
                    className="ns-btn--border manage-btn"
                    disabled={checkList.length < 1}
                    onClick={() => setDeleteGroup(true)}
                  >
                    {formatMessage({ id: 'dbi_delete_group' })}
                  </Button>
                </>
              }
              right={
                <>
                  <SearchRecent
                    fetchParams={{
                      entity_type: mainSegment,
                      unified_ids: [],
                    }}
                    placeholder={formatMessage(
                      { id: 'dbi_table_search_placeholder' },
                      {
                        domainName: formatMessage({
                          id: mainSegment === 'company' ? 'dbi_company_lower' : 'dbi_game_lower',
                        }),
                      },
                    )}
                    handleClear={handleClearSearch}
                    getTableResultList={getTableSearchList}
                    searchListApi={getFollowingSearch}
                    pageLogInfo={dbiPageLogMes.followingManageSearch}
                    searchType={`following-manage-${mainSegment}`}
                    initSearchInput={initSearchInput}
                    transTableDataForSearch={transTableDataForSearch}
                    recordNodataList={transTableDataForSearch2(defaultSearchNodataList)}
                  />
                </>
              }
            />

            <CardSlot>
              {loading ? (
                <div style={{ height: 606.69, color: '#444' }}>
                  <Loading content={formatMessage({ id: 'common_loading' })} />
                </div>
              ) : (
                <Table
                  className="dbi-manage-page-table"
                  records={groups}
                  recordKey="entity_name"
                  columns={[
                    {
                      key: 'allgroup',
                      header: (
                        <FollowMultipleChoice
                          checkList={checkList}
                          groupList={groupList}
                          DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
                          name={'allgroup'}
                          isAll={true}
                          onChange={(value: any) => {
                            getGroupCheckHandle(value, 'allgroup');
                          }}
                        />
                      ),
                      width: 37,
                      fixed: 'left',
                      render: (cvm: any) =>
                        cvm.entity_name == DEFAULT_GROUPNAME ? null : (
                          <FollowMultipleChoice
                            checkList={checkList}
                            groupList={groupList}
                            DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
                            name={cvm.entity_name}
                            onChange={(value: any) => {
                              getGroupCheckHandle(value, cvm.entity_name);
                            }}
                          />
                        ),
                    },
                    {
                      key: 'title',
                      header: formatMessage({ id: 'dbi_top_following_group' }),
                      render: (cvm) => {
                        const cvmEntityName = cvm?.entity_name;
                        const cvmNameText = SPECIAL_NAMES[cvmEntityName] || cvmEntityName;
                        const cvmNumText = cvm?.game_list_total || 0;
                        return (
                          <>
                            {cvmNameText}&nbsp;({cvmNumText})
                          </>
                        );
                      },
                    },
                    {
                      key: 'actions',
                      header: formatMessage({ id: 'dbi_actions' }),
                      width: 250,
                      render: (cvm) => (
                        <div className="table-btn-flex">
                          {cvm.entity_name === 'All Games' ? (
                            <>
                              <Button
                                type="link"
                                disabled={disAddToGroup}
                                onClick={() => {
                                  handleGroupSettingPre();
                                }}
                              >
                                {formatMessage({ id: 'dbi_add_to_group' })}
                              </Button>
                            </>
                          ) : cvm.entity_name == 'My favourite' ? (
                            <>
                              <Button
                                type="link"
                                onClick={() => {
                                  handleDuplicate(cvm);
                                }}
                              >
                                {formatMessage({ id: 'dbi_duplicate' })}
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button type="link" onClick={() => handleEditPre(cvm)}>
                                {formatMessage({ id: 'menu_rename' })}
                              </Button>
                              <Button
                                type="link"
                                onClick={() => {
                                  handleDuplicate(cvm);
                                }}
                              >
                                {formatMessage({ id: 'dbi_duplicate' })}
                              </Button>
                              <Button
                                type="link"
                                onClick={() => {
                                  handleDeletePre(cvm);
                                }}
                              >
                                {formatMessage({ id: 'dbi_delete' })}
                              </Button>
                            </>
                          )}
                        </div>
                      ),
                    },
                  ]}
                  addons={[
                    expandable({
                      expandedKeys,
                      onExpandedKeysChange: (keys, { event, operateType, operateKey }) => {
                        event.stopPropagation();
                        setExpandedKeys(keys);
                        if (operateType === 'expand' && operateKey) {
                          onGroupExpand(operateKey);
                        }
                      },
                      render: (group: IFollowingGroup) => {
                        const { entity_name: groupKey, game_list_total: groupGamesTotal } =
                          group || {};
                        // REMARK: 注意这里不能用||兜底，因为loadings?.[groupKey]的值 可能会true、false，如果值为false用||兜底了，就会改变最后的赋值了
                        const groupGamesLoading = loadings?.[groupKey] ?? true;
                        const sort = sorts?.[groupKey] || [];
                        const pagingQuery = pagingQuerys?.[groupKey] || {};
                        // 当前分组下的游戏集合（公司集合）
                        const groupGames = games?.[groupKey] || [];
                        const isDefaultGroupName = groupKey === 'All Games';

                        // 加载态UI
                        if (groupGamesLoading)
                          return (
                            <div className="dbi-manage-page-noDta">
                              <Loading content={formatMessage({ id: 'common_loading' })} />
                            </div>
                          );
                        // 无数据态UI
                        if (groupGamesTotal === 0 || !groupGames?.length)
                          return (
                            <div className="dbi-manage-page-noDta">
                              {renderGroupGamesNoDataUI(groupKey)}
                            </div>
                          );
                        // 有数据态UI
                        return (
                          <SubTable
                            gameList={groupGames}
                            total={groupGamesTotal}
                            OnUnfollow={() => setUnfollow(true)}
                            groupList={groupListCached}
                            groupName={groupKey}
                            setLoading={setLoading}
                            mainSegment={mainSegment}
                            setGroup={setGroup}
                            handleChangeSeg={handleChangeSeg}
                            DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
                            checkList={isDefaultGroupName ? checkAllGamesList : checkTableList}
                            // checkAllGamesList={checkAllGamesList}
                            setCheckList={
                              isDefaultGroupName ? setCheckAllGamesList : setCheckTableList
                            }
                            // setCheckAllGamesList={setCheckAllGamesList}
                            setCheckTrueGameIds={setCheckTrueGameIds}
                            checkTrueGameIds={checkTrueGameIds}
                            getPageDatas={getPageDatas}
                            setCheckListPa={setCheckList}
                            regionsCountries={regionsCountries}
                            MYFAVOURITE={MYFAVOURITE}
                            group={group}
                            sort={sort}
                            pagingQuery={pagingQuery}
                            onSortChange={(sort: any[]) => {
                              onGroupSortChange(groupKey, sort);
                            }}
                            onPagingChange={(pagingQuery: PagingQuery) => {
                              onGroupPagingQueryChange(groupKey, pagingQuery);
                            }}
                          />
                        );
                      },
                    }),
                    pageable(),
                  ]}
                />
              )}
            </CardSlot>
          </Content.Body>
        </Content>
      </Body>
      <RenameAddGroup
        onConfirm={handleChangeSeg}
        visible={createRenameGroup}
        groupName={groupName}
        setCreateRenameGroup={setCreateRenameGroup}
        mode={mode}
        mainSegment={mainSegment}
        openAddUpateGroup={isAddToGroup ? openAddUpateGroup : null}
        setAddNewGroupName={setAddNewGroupName}
        groupNames={groupNames}
      />
      <UnfollowModal
        visible={unfollow}
        setUnfollow={setUnfollow}
        click={() => cancelUnfollowing()}
      />
      <DeleteGroup
        visible={deleteGroup}
        DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
        setDeleteGroup={setDeleteGroup}
        onConfirm={handleChangeSeg}
        mainSegment={mainSegment}
        checkList={checkList}
      />
      <AddGroup
        visible={addGroup}
        close={handleAddGroupClose}
        entityType={mainSegment}
        userInfo={userInfo}
        gameId={checkTrueGameIds}
        gameIds={checkTrueGameIds}
        setFavarite={setFavarite}
        setAddGroup={setAddGroup}
        groupOptions={groupOptions}
        favarite={favarite}
        DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
        addNewGroupName={addNewGroupName}
        getPageDatas={getPageDatas}
        isMoveadd={true}
        isFromAllGames={true}
        getCreateGroup={() => {
          setAddGroup(false);
          setMode(FormMode.Add);
          setGroup(null);
          setCreateRenameGroup(true);
        }}
      />
      <AddEntities
        entityKey="gameId"
        visible={visible}
        entities={{
          game_type: mainSegment,
          user_id: userInfo?.userid,
        }}
        title={formatMessage({
          id: mainSegment === 'company' ? 'dbi_follow_new_companies' : 'dbi_follow_new_games',
        })}
        followedGameIdList={allGameListIds}
        entityType={mainSegment}
        pleaseSelectTips={formatMessage({
          id:
            mainSegment === 'company' ? 'dbi_please_a_select_company' : 'dbi_please_a_select_game',
        })}
        searchPlaceholder={formatMessage({
          id: mainSegment === 'company' ? 'dbi_search_any_company' : 'dbi_search_any_game',
        })}
        rightCellTitle={formatMessage({
          id: mainSegment === 'company' ? 'dbi_company_companies' : 'dbi_games',
        })}
        leftCellTitle={formatMessage({
          id:
            allGameTotal > 0
              ? mainSegment === 'company'
                ? 'dbi_top10_sum_rev'
                : 'dbi_compare_similar_games'
              : getLeftCellTitle(mainSegment),
        })}
        getSearchNewList={getSearchNewList}
        keywordsFetcher={followSearchPullDown}
        entitiesFetcher={getCompareEntityTypeSearch}
        similarEntitiesFetcher={getFollowingShuttleFrameList}
        onConfirm={handleFollowConfirm}
        regionsCountries={regionsCountries}
        onClose={() => setVisible(false)}
      />
    </Layout>
  );
}
